import hostyAppIcon from '@assets/images/hosty-app-icon.png';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePanelMenu } from '../../hooks/usePanelMenu';
import { Button } from '../ui/Button';
import { DemoBanner } from './DemoBanner';
import { PanelMobileHeader } from './PanelMobileHeader';
import './layouts.css';
import './client-panel.css';

const navItems = [
  { to: '/panel', label: 'Resumen', end: true },
  { to: '/panel/informes', label: 'Informes' },
  { to: '/panel/licencias', label: 'Licencias' },
  { to: '/panel/soporte', label: 'Soporte' },
  { to: '/panel/dispositivos', label: 'Dispositivos' },
  { to: '/panel/cuenta', label: 'Mi cuenta' },
];

export function PanelLayout() {
  const { user, logout, isDemo } = useAuth();
  const navigate = useNavigate();
  const { open, toggle, close } = usePanelMenu();

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  const brand = (
    <Link to="/" className="brand brand--panel">
      <img src={hostyAppIcon} alt="" className="brand__mark" width={32} height={32} />
      <span>
        Hosty <strong>Cloud</strong>
      </span>
    </Link>
  );

  return (
    <div className="panel-layout panel-layout--client">
      <PanelMobileHeader brand={brand} open={open} onToggle={toggle} />
      <button
        type="button"
        className={`panel-menu-overlay ${open ? 'is-open' : ''}`}
        aria-label="Cerrar menú"
        onClick={close}
        tabIndex={open ? 0 : -1}
      />
      <aside className={`panel-sidebar ${open ? 'is-open' : ''}`}>
        {brand}
        <nav className="panel-nav" aria-label="Panel de cliente">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className="panel-nav__link">
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="panel-sidebar__footer">
          <div className="panel-user">
            <strong>
              {user?.name} {user?.surname}
            </strong>
            <span>{user?.email}</span>
          </div>
          <Button variant="ghost" size="sm" onClick={handleLogout}>
            Cerrar sesión
          </Button>
        </div>
      </aside>
      <div className="panel-main">
        {isDemo ? (
          <div style={{ marginBottom: '1rem' }}>
            <DemoBanner />
          </div>
        ) : null}
        <Outlet />
      </div>
    </div>
  );
}
